"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCPF = void 0;
const cpf_cnpj_validator_1 = require("cpf-cnpj-validator");
/**
 * The "validateCPF" method tests if CPF is valid
 *
 * @param cpf
 * @returns
 */
const validateCPF = (cpf) => cpf_cnpj_validator_1.cpf.isValid(cpf, true);
exports.validateCPF = validateCPF;
